// Copyright (c) Zammo Inc.
import { css } from 'styled-components';

const breakpoints: { [key: string]: string } = {
  xxxl: '1600',
  xxl: '1439',
  xl: '1200',
  xlg: '1023',
  lg: '991',
  md: '768',
  sm: '575',
  xsm: '479',
};

/**
 * Genetares media queries with the breakpoints above.
 * @param string min or max the type of media queries to generate.
 * @return an object with keys the breakpoints keys.
 */
export const mediaFunc = (minOrMax: string) =>
  Object.keys(breakpoints).reduce((acc, label) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acc[label] = (literals: TemplateStringsArray, ...placeholders: any[]) =>
      css`
        @media (${minOrMax}-width: ${breakpoints[label]}px) {
          ${css(literals, ...placeholders)};
        }
      `.join('');
    return acc;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as Record<keyof typeof breakpoints, (l: TemplateStringsArray, ...p: any[]) => string>);

export default mediaFunc('max');
